import styled from 'styled-components';

const AddNewFamilyMemberSidebarStyled = styled.div`
  width: 100%;

  .form-label {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.text.medium} !important;
  }
`;

export default AddNewFamilyMemberSidebarStyled;
